if(!customElements.get('promotional-banner')){
    class PromotionalBanner extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.initializeSwiper();
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer) return;

            this.slides = this.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const autoplay = this.swiperContainer.dataset.autoplay === 'true';
            const speed = parseInt(this.swiperContainer.dataset.speed);
            const loop = this.swiperContainer.dataset.loop === 'true';
            const transition = this.swiperContainer.dataset.transition;

            const swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false
            }

            if(transition === 'fade'){
                swiperSettings.effect = 'fade';
                swiperSettings.fadeEffect = {
                    crossFade: true
                }
            }

            if(this.swiperContainer.querySelector(".swiper-navigation-wrapper")){
                swiperSettings.navigation = {
                    nextEl: this.swiperContainer?.querySelector('.button-next'),
                    prevEl: this.swiperContainer?.querySelector('.button-previous')
                }
            }


            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();


            this.setupFocusListeners();
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('promotional-banner', PromotionalBanner);
}